var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalisation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.063,
    height: 27.481,
    viewBox: "0 0 21.063 27.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-4340.071-119.38a10.548,10.548,0,0,0-7.228,2.749,10.865,10.865,0,0,0-3.289,8.22c0,5.885,9.712,15.916,10.125,16.341a.568.568,0,0,0,.4.171h0a.562.562,0,0,0,.4-.169c.415-.419,10.131-10.341,10.131-16.343C-4329.525-115.612-4334.831-119.38-4340.071-119.38Zm.017,26.1c-1.847-1.973-9.4-10.336-9.4-15.127a9.767,9.767,0,0,1,2.927-7.392,9.42,9.42,0,0,1,6.458-2.447c4.534,0,9.416,3.079,9.416,9.839C-4330.656-103.524-4338.206-95.24-4340.055-93.283Z",
    transform: "translate(4350.587 119.38)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-4325.107-101.68a5.554,5.554,0,0,0-5.548,5.548,5.554,5.554,0,0,0,5.548,5.548,5.555,5.555,0,0,0,5.548-5.548A5.555,5.555,0,0,0-4325.107-101.68Zm0,9.966a4.422,4.422,0,0,1-4.417-4.417,4.422,4.422,0,0,1,4.417-4.417,4.422,4.422,0,0,1,4.418,4.417A4.422,4.422,0,0,1-4325.107-91.714Z",
    transform: "translate(4335.638 106.105)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalisation);
export default __webpack_public_path__ + "static/media/localisation.45851017d427b787f960c4b6466065f6.svg";
export { ForwardRef as ReactComponent };